import { useEffect } from 'react';
import SliderType from '@/components/slider-type';
import MySlider from '@/components/my-slider/my-slider';
import { useAppDispatch, useAppSelector } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';
import { GeneralSlice } from '@/redux/general';
import { SliderSlice } from '@/redux/slider';
import '@/components/slider/slider-v1.css';
import '@/components/slider/slider-v2.css';

const Slider = (props) => {
  const cssVersion = useAppSelector(ConfigSlice.selectors.cssVersion);
  const questionsVisible = useAppSelector(SliderSlice.selectors.questionsVisible);
  const currentId = useAppSelector(SliderSlice.selectors.currentId);
  const config = useAppSelector(ConfigSlice.selectors.config);
  const isFormSubmitted = useAppSelector(SliderSlice.selectors.isFormSubmitted);
  const showNewTanksPage = useAppSelector(GeneralSlice.selectors.showNewTanksPage);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(SliderSlice.actions.fillSliderSliceWithInitialData(config.questions));
  }, [config]);

  useEffect(() => {
    dispatch(GeneralSlice.actions.setPage('slider'));
  }, []);

  return !isFormSubmitted && !showNewTanksPage ? (
    <div data-css-version={cssVersion} className='slider'>
      <MySlider position={currentId} afterChange={props.afterChange}>
        {questionsVisible.map((slide, index) => (
          <SliderType
            key={slide.key}
            index={index}
            slide={slide}
            nextSlide={props.nextSlide}
            prevSlide={props.prevSlide}
            onSubmit={props.onSubmit}
          />
        ))}
      </MySlider>
    </div>
  ) : null;
};

export default Slider;
